import React, { Component } from 'react';
import {
  ReviewsStateContext,
  ReviewsStateConsumer
} from '../../context/ReviewsContext';

import ReviewsRating from './ReviewRating';

class ReviewsCount extends Component {
  componentDidMount() {
    this.context.getReviewsCountForItem(this.props.type, this.props.slug);
  }

  render() {
    return (
      <ReviewsStateConsumer>
        {reviewsStateContext => {
          const { reviewsCount } = reviewsStateContext;
          return (
            <>
            {reviewsCount.count >= 5 ? (
            <span className="star-count">
              <ReviewsRating initialRating={reviewsCount.avgRating} />
              <span className="review-total">
                <span className="review-count">
                  &nbsp; {reviewsCount.avgRating}/5 ({reviewsCount.count}{' '}
                  Reviews
                </span>
                )
              </span>
            </span>
          ) : ( null )}
            </>
          );
        }}
      </ReviewsStateConsumer>
    );
  }
}

ReviewsCount.contextType = ReviewsStateContext;

export default ReviewsCount;
